export default __webpack_public_path__ + "static/media/AdamaLovelace.d3053f60.png";